import { useAssignedClientSelection } from "../../../hooks";
import { CoiPumpAdmin } from "./CoiPumpAdmin";

export const CoiPumpClient = () => {
  const { clientOptions, selectedClientId, setSelectedClientId } =
    useAssignedClientSelection();

  return (
    <CoiPumpAdmin
      clientMode
      assignedClientOptions={clientOptions}
      assignedClientId={selectedClientId}
      onAssignedClientChange={setSelectedClientId}
    />
  );
};
